import React, { useEffect, useRef, useState } from "react";
import { Header } from "homepage/homeHeader";
import { HomeFooter } from "homepage/homeFooter";
import { Formik, ErrorMessage, Form, Field } from "formik";
import * as Yup from "yup";
import {
  LoadCanvasTemplateNoReload,
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";
import api from "services/api";
import { toast } from "react-toastify";

const initialValues = {
  name: "",
  phone_no: "",
  org_name: "",
  email: "",
  subject: "",
  call_back: "",
  description: "",
  attach_file: "",
  enquiry_type: "",
  // captcha: "", // Add this line
};

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Required")
    .min(3, "Name must be at least 3 characters")
    .matches(/^[a-zA-Z ]*$/, "Name can only contain letters and spaces"),
  phone_no: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Required"),
  org_name: Yup.string().min(
    3,
    "Organization Name must be at least 3 characters"
  ),
  email: Yup.string()
    .email("Invalid email format")
    .matches(
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      "Invalid email format"
    )
    .required("Required"),
  subject: Yup.string().required("Required"),
  enquiry_type: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  call_back: Yup.string().required("Required"),
  // attach_file: Yup.mixed(),
  // captcha: Yup.string().required("CAPTCHA is required"), // Add this line
});
const ContactUsForm = () => {
  const [userCaptcha, setUserCaptcha] = useState("");
  const attchRef = useRef();

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  const handleRefreshCaptcha = () => {
    loadCaptchaEnginge(6);
  };

  const hadleSubmit = async (values, resetForm) => {
    if (!userCaptcha) {
      toast.error("Please enter captcha");
      return;
    }
    if (!validateCaptcha(userCaptcha)) {
      toast.error("Invalid CAPTCHA. Please try again.");
      return;
    }
    if (!values.attach_file) {
      values.attach_file = "";
    }
    const formData = new FormData();

    for (const key in values) {
      formData.append(key, values[key]);
    }
    try {
      const response = await api.post("/contact-us", formData);
      // attchRef.current.value = null;
      resetForm();
      setUserCaptcha("");
      console.log("fetContactUs :", response);
      toast.success(response?.data?.message);
    } catch (error) {
      console.log("fetContactUs Error:", error);
      toast.error(error?.response?.data?.message || "error");
    }
  };

  const handleAttchFile = (e, setFieldValue) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSizeInBytes = 800 * 1024;

    if (file) {
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG,GIF,or PNG files are allowed");
        setFieldValue("attach_file", "");
        attchRef.current.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        toast.error("File size should not exceed 800KB.");
        setFieldValue("attach_file", "");
        attchRef.current.value = null;

        return;
      }

      setFieldValue("attach_file", file);
    } else {
      setFieldValue("attach_file", "");
    }
  };
  return (
    <div className="d-flex justify-content-center ">
      <div class="col-md-6 ">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            console.log("values:", values);
            hadleSubmit(values, resetForm);
          }}
        >
          {({ setFieldValue, errors, resetForm }) => (
            <Form>
              {console.log("errors:", errors)}
              <div class="card mb-4">
                <div class="card-body ">
                  <h4 className="mb-1">Let's talk</h4>
                  <p className="mb-4 " style={{ textAlign: "justify" }}>
                    For information about Zenosure membership, plans
                    (individual, family, or corporate), partnerships, or bulk
                    purchases, please fill out the form below we’ll get
                    back to you shortly.
                  </p>
                  <div className="d-flex flex-column">
                    <div className="mb-3 ">
                      <label
                        for="username"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Name
                        <span className="invalid-form">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="name"
                        placeholder="Name"
                        autofocus
                        onChange={(e) => {
                          if (/^[A-Za-z .,;:'"0-9]*$/.test(e.target.value)) {
                            setFieldValue("name", e.target.value);
                          }
                        }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="email"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Email ID <span className="invalid-form">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="email"
                        placeholder="Email"
                        autofocus
                        onChange={(e) => {
                          if (/^[a-zA-Z0-9@.]*$/.test(e.target.value)) {
                            setFieldValue("email", e.target.value);
                          }
                        }}
                      />

                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="phone_no"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Contact Number
                        <span className="invalid-form">*</span>
                      </label>
                      <Field
                        type="tel"
                        className={`form-control`}
                        name="phone_no"
                        placeholder="Contact Number"
                        autofocus
                        maxLength="10"
                        onChange={(e) => {
                          if (/^[0-9]*$/.test(e.target.value)) {
                            setFieldValue("phone_no", e.target.value);
                          }
                        }}
                      />

                      <ErrorMessage
                        name="phone_no"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="enquiry_type"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Please Select
                        <span className="invalid-form">*</span>
                      </label>
                      <Field
                        as="select"
                        className={`select2 form-select`}
                        //   name="email"
                        //   placeholder="Email"
                        autofocus
                        name="enquiry_type"
                      >
                        <option value="">Select</option>
                        <option value="Sales Enquiry">Sales Enquiry</option>
                        <option value="Support Enquiry">Support Enquiry</option>
                        <option value="Billing Enquiry">
                          Billing Enquiry{" "}
                        </option>
                      </Field>

                      <ErrorMessage
                        name="enquiry_type"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="subject"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Subject
                        <span className="invalid-form">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="subject"
                        placeholder="Subject"
                        autofocus
                        //   maxLength="10"
                        onChange={(e) => {
                          if (/^[a-zA-Z0-9 .,;:'"]*$/.test(e.target.value)) {
                            setFieldValue("subject", e.target.value);
                          }
                        }}
                      />

                      <ErrorMessage
                        name="subject"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="description"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Message <span className="invalid-form">*</span>
                      </label>
                      <Field
                        as="textarea"
                        className="form-control"
                        name="description"
                        placeholder="Enter your description here..."
                        rows="2"
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="org_name"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Organization Name
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="org_name"
                        placeholder="organization Name"
                        autofocus
                        onChange={(e) => {
                          if (/^[a-zA-Z0-9 .,;:'"]*$/.test(e.target.value)) {
                            setFieldValue("org_name", e.target.value);
                          }
                        }}
                      />
                      <ErrorMessage
                        name="org_name"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div>

                    <div
                      className="mb-3 d-flex flex-wrap"
                      style={{ gap: "1rem" }}
                    >
                      <div style={{ flex: "1", minWidth: "250px" }}>
                        <label
                          htmlFor="call_back"
                          className="form-label d-block"
                          style={{ textAlign: "left" }}
                        >
                          Get a Callback <span className="invalid-form">*</span>
                        </label>
                        <Field
                          as="select"
                          className={`select2 form-select`}
                          autofocus
                          name="call_back"
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Field>
                        <ErrorMessage
                          name="call_back"
                          component="div"
                          className="invalid-form"
                          style={{ textAlign: "left" }}
                        />
                      </div>
                      {/* <div style={{ flex: "1" , minWidth: "250px"}}>
                      <label
                        htmlFor="attach_file"
                        className="form-label d-block"
                        style={{ textAlign: "left" }}
                      >
                        Attach File
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        name="attach_file"
                        onChange={(e) => handleAttchFile(e, setFieldValue)}
                        ref={attchRef}
                      />
                      <div className="text-muted " >
                        Allowed JPG, GIF or PNG. Max size of 800 KB
                      </div>
                      <ErrorMessage
                        name="attach_file"
                        component="div"
                        className="invalid-form"
                        style={{ textAlign: "left" }}
                      />
                    </div> */}
                    </div>
                    <div
                      className="mb-3 d-flex flex-wrap"
                      style={{ gap: "1rem" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter CAPTCHA"
                        value={userCaptcha}
                        onChange={(e) => {
                          setUserCaptcha(e.target.value);
                          console.log("e:", e.target.value);
                        }}
                        style={{ flex: "1", minWidth: "200px" }}
                      />
                      <div
                        className="d-flex align-items-center"
                        style={{
                          flex: "1",
                          justifyContent: "space-between",
                          minWidth: "200px",
                        }}
                      >
                        <span style={{ flexShrink: 1 }}>
                          <LoadCanvasTemplateNoReload />
                        </span>
                        <button
                          className="btn btn-secondary"
                          type="button"
                          onClick={handleRefreshCaptcha}
                          style={{ flexShrink: 0 }}
                        >
                          Refresh
                        </button>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-primary d-grid " type="submit">
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ContactUsForm;
